var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.248 5.24915C12.0953 5.4049 12.0098 5.61429 12.0098 5.83238C12.0098 6.05048 12.0953 6.25987 12.248 6.41562L13.5811 7.74874C13.7369 7.9014 13.9463 7.98691 14.1643 7.98691C14.3824 7.98691 14.5918 7.9014 14.7476 7.74874L17.3355 5.16166C17.6021 4.89337 18.0545 4.97836 18.1545 5.3433C18.4063 6.25888 18.392 7.22721 18.1135 8.135C17.835 9.04279 17.3037 9.85247 16.5818 10.4693C15.8599 11.0862 14.9772 11.4847 14.0371 11.6182C13.097 11.7517 12.1383 11.6146 11.2732 11.2232L4.68257 17.8137C4.35111 18.1451 3.90159 18.3312 3.4329 18.3311C2.96422 18.331 2.51476 18.1448 2.1834 17.8133C1.85205 17.4819 1.66594 17.0323 1.66602 16.5637C1.66609 16.095 1.85235 15.6455 2.18382 15.3142L8.7744 8.72357C8.38292 7.85848 8.24591 6.89978 8.37941 5.95965C8.51291 5.01953 8.9114 4.13687 9.52824 3.41496C10.1451 2.69305 10.9548 2.16175 11.8626 1.88323C12.7703 1.6047 13.7387 1.59047 14.6543 1.84221C15.0192 1.94219 15.1042 2.39379 14.8367 2.66207L12.248 5.24915Z",
    stroke: "white",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.facc6edc7a95c99ae72c3ceccc04c14c.svg";
export { ForwardRef as ReactComponent };